module.exports = __webpack_public_path__ + "static/media/4.2c8fd6fa.jpg";